import { useForm } from '@mantine/form';
import { z } from 'zod';
import { getValidateErrors } from '@/lib/utils/validation';
import { IcapServerDto } from '@/services/api/dlpSettingsApiArea/types';

const schema = z.object({
  Host: z.string().min(1, 'Адрес обязателен'),
  Port: z.coerce.number().min(1, 'Порт обязателен').max(65535, 'Некорректный порт'),
  ReqmodService: z.string(),
  RespmodService: z.string()
});

type FormValues = z.infer<typeof schema>;

interface UseServerSettingsProps {
  server?: IcapServerDto;
  onClose: () => void;
  onSuccess: (server: IcapServerDto) => void;
}

export const useServerSettings = ({ server, onClose, onSuccess }: UseServerSettingsProps) => {
  const form = useForm<FormValues>({
    validateInputOnChange: true,
    initialValues: server
      ? {
          Host: server.Host,
          Port: server.Port,
          ReqmodService: server.ReqmodService,
          RespmodService: server.RespmodService
        }
      : {
          Host: '',
          Port: 80,
          ReqmodService: '/',
          RespmodService: '/'
        },
    validate: (values) => getValidateErrors(schema, values)
  });

  const handleSubmit = () => {
    const validation = form.validate();
    if (validation.hasErrors) return;

    const newServer: IcapServerDto = {
      Name: server?.Name || '',
      Host: form.values.Host,
      Port: form.values.Port,
      ReqmodService: form.values.ReqmodService,
      RespmodService: form.values.RespmodService
    };

    onSuccess(newServer);
    onClose();
  };

  return [form, handleSubmit] as const;
};
